import Header from './header/Header';
import Content from './content/Content';
import LeftSideMenu from './left-side-bar/LeftSideMenu';
import Footer from './footer/Footer';
import MainLayout from './main/MainLayout';

export { Header, Content, LeftSideMenu, Footer, MainLayout };